import { createActorContext } from '@xstate/react';

import { periodicRemoteFileSyncMachine } from '../periodicRemoteFileSync.machine';

export const PeriodicRemoteFileSyncContext = createActorContext(
  periodicRemoteFileSyncMachine,
);

export const usePeriodicRemoteFileSyncActor =
  PeriodicRemoteFileSyncContext.useActorRef;

export const usePeriodicRemoteFileSyncSelector =
  PeriodicRemoteFileSyncContext.useSelector;

export const useIsUploadInProgressForAppointment = (appointmentId: string) =>
  usePeriodicRemoteFileSyncSelector(
    (s) =>
      s.context.currentFile?.appointmentId === appointmentId ||
      s.context.fileQueue.filter((q) => q.appointmentId === appointmentId)
        .length > 0,
  );
